import { createGlobalStyle } from 'styled-components'

import { themeEstra } from 'src/styles/themeEstra'

export const GlobalStyle = createGlobalStyle`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  
  body {
    margin: 0;
    font-family: ${themeEstra.fontFamily.base};
    background-color: ${themeEstra.body.bg};
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: ${themeEstra.body.color};
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba($black, 0);
    /* For offgrid elements like agenti/Blob */
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, p {
    margin: 0;
  }

  a {
    color: ${themeEstra.link.color};
    text-decoration: none;

    &:hover {
      opacity: 0.8
    }
  }
`
